import { createContext, useContext } from 'react';
import { DashboardSidebarRightTabsType } from '@types';
import { ProcDetailsResponse, StepItemResponse } from '@/shared/api';

type EditProcContextType = {
  proc?: ProcDetailsResponse;
  selectedComponent?: any;
  setSelectedComponent: (component: any) => void;
  selectedStep?: Partial<StepItemResponse>;
  setSelectedStep: (step: Partial<StepItemResponse | undefined>) => void;
  commentsLabel?: string;
  setCommentsLabel: (val: string) => void;
  editFormLoading?: boolean;
  setEditFormLoading: (val: boolean) => void;
  rightSidebarActiveTab?: DashboardSidebarRightTabsType;
  setRightSidebarActiveTab: (val: DashboardSidebarRightTabsType) => void;
  changesSaved?: boolean;
  setChangesSaved: (changesSaved: boolean) => void;
  resetLogicCount?: number;
  setResetLogicCount: (resetLogicCount: number) => void;
  aiAssistantStepContext?: string;
  setAiAssistantStepContext: (val: string) => void;
};

export const EditProcContext = createContext<EditProcContextType>(
  {} as EditProcContextType,
);

export const useProcContext = () => useContext(EditProcContext);
